export const gql = (query: TemplateStringsArray): string => {
  return query[0]
}
